import styles from './contextCardRow.module.scss'

export default function ContextAppIcon({ src, alt = '' }) {
  if (!src) return <span className={styles.iconSlot} aria-hidden />
  return (
    <img className={styles.iconSlot} src={src} alt={alt} width={24} height={24} />
  )
}
